import { APP_STORE, GOOGLE_PLAY, dispositivoDa, type Dispositivo } from "@/lib/scaricaApp";

/**
 * Il banner «Scarica l'app» in cima al sito aperto dal telefono (23/10/2026).
 *
 * PERCHE' (incontro del 22/10, Davide): chi apre Datacom AI dal browser del
 * telefono deve sapere che c'e' l'app, dove arrivano le notifiche di Datacom.
 * Vale per tutti, non solo per gli invitati della campagna. Pagina della scelta:
 * docs/design/dalla_mail_all_app_2026-10-23.html (punto 3, versione 3 scelta da
 * Davide). Lo stesso testo va sul negozio B2B: la scheda per quella sessione e'
 * ~/Drive/claude-code-logs/prompt-progetti/BANNER_APP_testo-scelto.md. Se si
 * cambia una parola qui, si cambia anche li'.
 *
 * LE REGOLE
 * - Solo dal browser di un telefono o tablet; mai nell'app, mai sul computer.
 * - iPhone in Safari: c'e' gia' il banner di Apple (`apple-itunes-app` in
 *   index.html), il nostro no: mai due insieme.
 * - Si chiude con la × e non torna per 14 giorni.
 * - Sta dentro la pagina, in cima, e la spinge giu': non copre mai il campo di
 *   accesso ne' la barra dove si scrive (vedi `con-banner-app` in index.css).
 */

export const TESTO_BANNER_APP = "Hai l'app Datacom AI? Aprila. Non ce l'hai? È gratis.";
export const TASTO_BANNER_APP = "Apri";
export const GIORNI_BANNER_CHIUSO = 14;
export const CHIAVE_BANNER_CHIUSO = "datacom.bannerApp.chiusoIl";

/** Le pagine dove non serve: sono gia' la porta verso l'app, o sono da stampare. */
const PAGINE_SENZA_BANNER = ["/app", "/benvenuto", "/continua-nell-app", "/cartello-stampa"];

export function rigaStore(d: Dispositivo): string {
  return d === "iphone" ? "Su App Store" : "Su Google Play";
}

export function storeDi(d: Dispositivo): string | null {
  if (d === "iphone") return APP_STORE;
  if (d === "android") return GOOGLE_PLAY;
  return null;
}

/**
 * Il Safari «vero» dell'iPhone, dove Apple mostra il suo banner. Gli altri
 * browser dell'iPhone si dichiarano nell'user agent (CriOS = Chrome, FxiOS =
 * Firefox, EdgiOS, OPiOS, GSA = app Google, FBAN/FBAV/Instagram = browser delle
 * app social); i browser interni costruiti su WKWebView non hanno «Safari/».
 */
export function safariDiApple(userAgent: string, puntiTattili = 0): boolean {
  return (
    dispositivoDa(userAgent, puntiTattili) === "iphone" &&
    /Safari\//.test(userAgent) &&
    /Version\//.test(userAgent) &&
    !/CriOS|FxiOS|EdgiOS|OPiOS|GSA\/|FBAN|FBAV|Instagram|GmailiOS/i.test(userAgent)
  );
}

export function chiusoDaPoco(valore: string | null, adesso = Date.now()): boolean {
  if (!valore) return false;
  const quando = Date.parse(valore);
  if (Number.isNaN(quando)) return false;
  return adesso - quando < GIORNI_BANNER_CHIUSO * 86_400_000;
}

export function mostraBannerApp(o: {
  nativa: boolean;
  userAgent: string;
  puntiTattili: number;
  percorso: string;
  chiusoIl: string | null;
  installataComeSito?: boolean;
  adesso?: number;
}): boolean {
  if (o.nativa) return false;
  // Aggiunta alla schermata Home come sito: niente barra del browser sopra,
  // e il banner finirebbe sotto l'orologio.
  if (o.installataComeSito) return false;
  const d = dispositivoDa(o.userAgent, o.puntiTattili);
  if (d === "computer" || !storeDi(d)) return false;
  if (safariDiApple(o.userAgent, o.puntiTattili)) return false;
  if (PAGINE_SENZA_BANNER.some((p) => o.percorso === p || o.percorso.startsWith(`${p}/`))) return false;
  return !chiusoDaPoco(o.chiusoIl, o.adesso);
}

export function leggiChiusura(): string | null {
  try {
    return localStorage.getItem(CHIAVE_BANNER_CHIUSO);
  } catch {
    return null;
  }
}

export function segnaChiusura(adesso = new Date()): void {
  try {
    localStorage.setItem(CHIAVE_BANNER_CHIUSO, adesso.toISOString());
  } catch {
    // navigazione privata: si chiude lo stesso, per questa visita
  }
}
